import { Drawer, Spin } from "antd";
import i18n from "i18next";
import type { FC, ReactNode } from "react";

import { SecondaryButton } from "../../Buttons/components/ActionButton";
import { DRAWER_SIZE } from "../drawerFormStyles";

type BatchUpdateDrawerButtonProps = {
    isDisabled?: boolean;
    open: boolean;
    onOpen: () => void;
    onClose: () => void;
    titleKey: string;
    isSubmitting?: boolean;
    children: ReactNode;
};

// Shared button + drawer shell for batch update forms; the specific filter form is passed as children.
export const BatchUpdateDrawerButton: FC<BatchUpdateDrawerButtonProps> = ({
    isDisabled,
    open,
    onOpen,
    onClose,
    titleKey,
    isSubmitting,
    children,
}) => (
    <>
        <SecondaryButton name="batch_update_button" onClick={onOpen} disabled={isDisabled}>
            {i18n.t("button.batchUpdate")}
        </SecondaryButton>
        <Drawer
            title={i18n.t(titleKey)}
            closable={!isSubmitting && { "aria-label": "Close Button" }}
            mask={{ closable: !isSubmitting }}
            size={DRAWER_SIZE}
            onClose={onClose}
            open={open}
        >
            <Spin spinning={isSubmitting}>{children}</Spin>
        </Drawer>
    </>
);
